import Vue from 'vue'
import Vuex from 'vuex'

import params from './modules/params'

Vue.use(Vuex)

// const store = new Vuex.Store(user)
/**
 *  放弃使用 vuex 已经无法扩展只能堆积到
 *
 * @type {Store}
 */


const store = new Vuex.Store(params)

export default store



// WEBPACK FOOTER //
// ./src/store/index.js